/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import { Card, Divider, Grid, Rating, Tooltip, Typography, useMediaQuery, Zoom } from '@mui/material'
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';

import InnerHeadRoutes from 'components/Common/InnerHeadRoutes/InnerHeadRoutes';
import { BsListUl } from "react-icons/bs";

import InputFormItem from 'components/Common/ElementInForm/InputFormItem';
import { BtnAddForm, BtnRecycle, BtnSave, BtnBack, BtnHome, BtnSearchOnTable, BtnSend, BtnReject, BtnRating, BtnRecomment, BtnCancelInModal } from 'components/Common/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import RadioFormItem from 'components/Common/ElementInForm/RadioFormItem';
import UploadFile from 'components/Common/ElementInForm/UploadFile/UploadFile';
import { AlertTitle, AxiosGet, AxiosPost, Extension, ResultAPI } from 'service/CommonFunction/TS_function';
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect';
import { SwAlert } from 'components/Common/Alert/AlertForm';
import { SnackbarCustom } from 'components/Common/Alert/Snackbars/Snackbar';
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import { useLocation, useNavigate } from 'react-router-dom';
import VerticalStepper from 'components/Stepper/VerticalStepper';
import CardBox from 'components/CardBox/CardBox';
import { AiFillWechat } from "react-icons/ai";
import moment from 'moment';
import { GridColumns } from '@mui/x-data-grid-pro';
import { DataGridMuiClient } from 'components/Common/Table/DataGridMuiClient';
import ModalReject from './ModalReject';
import ModalRating from './ModalRating';
import InputCustomLabel from 'components/Common/ElementInForm/InputCustomLabelFormItem';
import { i18n } from 'i18n';
import Accordion from 'components/Common/Accordion/Accordion';
import { currentLanguage } from 'service/CommonFunction/AxiosConfig';
import PopUpCustom from 'components/PopupCustom/PopUpCustom';
const i18nField = 'entities.HomeVOCForm.fields';

const HomeVOCForm = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const Layout1000 = useMediaQuery('(min-width:1000px)');

    const { BlockUI, UnBlockUI } = FnBlock_UI();

    const [sVOCFormID, setsVOCFormID] = useState(location?.state ? location.state["sVOCFormID"] : null)

    const [sDate, setsDate] = useState("-")
    const [sStatus, setsStatus] = useState("-")
    const [sResponeName, setsResponeName] = useState("-")
    const [sBAserviceVOC, setsBAserviceVOC] = useState("-")
    const [IsShowChatBA, setIsShowChatBA] = useState(false)
    const [IsShowChatEmp, setIsShowChatEmp] = useState(false)
    const [nTo, setnTo] = useState(0)

    const [IsCheckTel, setIsCheckTel] = useState(false)
    const [arrAttachment, setarrAttachment] = useState([] as any)
    const [nStatusID, setnStatusID] = useState(null)
    const [IsReferVOC, setIsReferVOC] = useState(false)
    const [sMode, setsMode] = useState("")
    const [DataRowResolve, setDataRowResolve] = useState([] as any)       //List Note
    const [nJobTypeID, setnJobTypeID] = useState(1)
    const [DataRowInprogress, setDataRowInprogress] = useState([] as any)
    const [nChatID, setChatID] = useState<number>(0);
    //SnankBar
    const [IsOpenSnackbar, setIsOpenSnackbar] = useState(false)
    const [sSeveritySnackbar, setsSeveritySnackbar] = useState("success")
    const [sMessageSnackbar, setsMessageSnackbar] = useState(null) as any
    const [IsAlertInfo, setIsAlertInfo] = useState(false)


    const [IsOpenRating, setIsOpenRating] = useState(false)
    const [IsOpenReject, setIsOpenReject] = useState(false)

    const [OptionTypeVOC, setOptionTypeVOC] = useState([] as any);
    const [OptionTel, setOptionTel] = useState([] as any);
    const [OptionCompany, setOptionCompany] = useState([] as any);
    const [Optionlocation, setOptionlocation] = useState([] as any);
    const [objScore, setobjScore] = useState({
        lstQ: [],
        sSuggestion: "-",
        isShow: false
    })
    const [DataUser, setDataUser] = useState({
        "nUserID": null,
        "sUserCode": null,
        "sFullname": null,
        "sAPIRoleName": null,
        "sUserType": null,
        "lstCompany": [],
        "lstUserBA": []
    })

    const schema = yup.object().shape({
        sVOCForm: yupFormSchemas.string(i18n(`${i18nField}.sInvoice`), { required: false }),
        sJobCode: yupFormSchemas.string(i18n(`${i18nField}.sSheet`), { required: false }),
        sReferVOCFormCode: yupFormSchemas.string(i18n(`${i18nField}.sReference`), { required: false }),
        oVOCType: yupFormSchemas.object(i18n(`${i18nField}.sType`), { required: false }),
        sDetail: yupFormSchemas.string(i18n(`${i18nField}.sDetail`), { required: false }),
        oTel: yupFormSchemas.object(i18n(`${i18nField}.sTel`), { required: false }),
        oCompany: yupFormSchemas.object(i18n(`${i18nField}.sCompany`), { required: false }),
        oAddress: yupFormSchemas.object(i18n(`${i18nField}.sAddress`), { required: false }),
    });

    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
        criteriaMode: "firstError"
    })

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
        GetUserData();
        const urlParams = new URLSearchParams(location.search);
        const sParamVOCFormID = urlParams.get("strMail");
        let sParamVOCID = "";
        let IsFromMail = false;
        if((location.state && location.state["sVOCFormID"]))
        {
            sParamVOCID = location?.state["sVOCFormID"];
            setsVOCFormID(location?.state["sVOCFormID"])
            IsFromMail = false;
        }
        else if(sParamVOCFormID)
        {
            sParamVOCID = sParamVOCFormID;
            setsVOCFormID(sParamVOCFormID)
            IsFromMail = true;
        }

        //Get Data for update
        if (sParamVOCID != "") {
            setsVOCFormID(sParamVOCID)
            GetScoreQueationair(sParamVOCID);
            GetDataVOCID(sParamVOCID);
        }
    }, [location?.state])

    const GetUserData = async () => {
        AxiosGet("User/GetUserData", { "sLanguage": currentLanguage() }, (res) => {
            ResultAPI(res, null, () => {
                let lstIntBA = (res.result.lstUserBA || []).map(m => m.nBAID);
                setDataUser({
                    "nUserID": res.result.nUserID || "",
                    "sUserCode": res.result.sUserCode || "",
                    "sFullname": res.result.sFullname || "",
                    "sAPIRoleName": res.result.sAPIRoleName || "",
                    "sUserType": res.result.sUserType || "",
                    "lstCompany": res.result.lstCompany || [],
                    "lstUserBA": lstIntBA || [],
                });
            })
        })
    };
    const GetScoreQueationair = (sParamVOCFormID) => {
        BlockUI();
        AxiosGet(`VOC/GetScoreQueationair`, { sVOCFormID: sParamVOCFormID, "sLanguage": currentLanguage() }, (res) => {
            UnBlockUI();
            ResultAPI(res, null, () => {

                setobjScore({
                    lstQ: res.Result || [],
                    sSuggestion: res.sSuggestion,
                    isShow: res.isShow,
                })
            })
        })
    }

    const GetDataVOCID = async (sParamVOCFormID) => {
        BlockUI();
        await AxiosGet(`VOC/VOCFormDataByID`, { sVOCFormID: sParamVOCFormID, "sLanguage": currentLanguage() }, (res) => {
            UnBlockUI();
            ResultAPI(res, null, async () => {
                setIsShowChatBA(res.IsShowChatBA ?? false)
                setIsShowChatEmp(res.IsShowChatEmp ?? false);

                setChatID(res.nChatID ?? 0);
                let Result = res?.result?.data
                if (Result != null) {

                    setnStatusID(Result.nStatusID)
                    setnJobTypeID(Result.nJobTypeID);
                    form.setValue("sVOCForm", Result.sVOCFormCode)
                    form.setValue("sJobCode", Result.sJobCode)
                    form.setValue("sReferVOCFormCode", Result.sRefVOCCode ?? null)
                    setIsReferVOC(Result.isReferVOC ?? false)

                    form.setValue("oVOCType", Result.objVOCType)
                    form.setValue("sDetail", Result.sDetail)
                    form.setValue("oTel", Result.objTel)
                    form.setValue("oCompany", Result.objCompany)
                    form.setValue("oAddress", Result.objAddr)

                    form.setValue("sResolveDetail", Result.objFormData.sResloveDetail)

                    let nToUser = null;
                    switch (Result.objFormData.nResponsibleTypeID) {
                        case 22:
                            nToUser = res.nUserEmp;
                            break;
                        case 23:
                        case 24:
                            nToUser = res.nUserBA;
                            break;
                    }
                    setnTo(nToUser)

                    setIsCheckTel(Result.IsAllowContact)
                    setarrAttachment(Result.lstFormFile)
                    let sIssueDate = Result.dIssueDate != null ?
                        (currentLanguage() == "th" ? moment(Result.dIssueDate).add(543, 'year').format("DD/MM/YYYY HH:mm น.") + "" : moment(Result.dIssueDate).format("DD/MM/YYYY HH:mm"))
                        :
                        "-";
                    setsDate(sIssueDate)
                    let sStatus = Result.sStatus ?? "-"
                    setsStatus(sStatus)
                    let sRespon = Result.sActionRespon ?? "-"
                    setsResponeName(sRespon)
                    let sCreate = Result.sActionCreate ?? "-"

                    setsBAserviceVOC(sCreate)
                    setDataRowResolve(Result.lstRequestTypeFile || [])

                }

            })
        })

        let data = {
            sVOCFormID: sParamVOCFormID,
        }

        await AxiosPost(`VOC/GetNotifyProgress`, data, (res) => {
            ResultAPI(res, null, async () => {
                let Result = res.result.data
                if (Result != null) {
                    setDataRowInprogress(Result)
                }
            })
        })
    }

    const onGotoBack = () => {
        let sUrl = -1 as any;
        const queryString = location.search;
        const urlParams = new URLSearchParams(queryString);
        const strMail = urlParams.get("strMail");
        
        if(strMail != null && strMail != "")
        {
            sUrl = "/Front/MyVOC";
        }
        navigate(sUrl);
    }

    const GotoFilePath = (item) => {
        window.open(item.row?.sFileLink ?? "/");
    }


    const GotoReferVOC = () => {
        let StrUrl = "/Front/VOCForm";
        navigate(StrUrl,
            {
                state:
                {
                    sVOCFormID: sVOCFormID,
                    sMode: "Refer",
                }
            }
        );
    }


    // const onGotoLiveChat = () => {
    //     let StrUrl = "/Front/MyVOC/LiveChatVOC";
    //     navigate(StrUrl,
    //         {
    //             state:
    //             {
    //                 sVOCFormID: sVOCFormID,
    //                 nChatID: nChatID,
    //             }
    //         }
    //     );
    // }

    const onGotoLiveChat = async () => {

        //Create nChatID 
        let nChatID = 0;
        await AxiosGet(`VOC/GetCreateChatID`, { "sVOCFormID": sVOCFormID, "nFrom": DataUser.nUserID, "nTo": nTo }, (res) => {
            ResultAPI(res, null, () => {
                nChatID = res.nChatID;
            })
        });

        // //Jo Fix Issue Chat
        // await AxiosGet(`VOC/GetCreateChatID`, { "sVOCFormID": sVOCFormID }, (res) => {
        //     ResultAPI(res, null, () => {
        //         nChatID = res.nChatID;
        //     })
        // });

        await GotoChat(nChatID);

    }

    const GotoChat = async (nChatID) => {
        let StrUrl = "/Front/MyVOC/LiveChatVOC";
        navigate(StrUrl,
            {
                state:
                {
                    sVOCFormID: sVOCFormID,
                    nChatID: nChatID
                }
            }
        );
    }


    const dataColumn: GridColumns = [
        {
            field: "nRow",
            headerName: i18n(`${i18nField}.sNo`),
            headerAlign: "center",
            width: 40,
            editable: false,
            resizable: false,
            disableReorder: true,
            align: "center",
            sortable: false,
        },
        {
            field: "sFileName",
            headerName: i18n(`${i18nField}.sDoc`),
            headerAlign: "center",
            flex: 1,
            align: "left",
            resizable: false,
            disableReorder: true,
            minWidth: 130,
            sortable: false,
            renderCell: (item) => {
                return (
                    <>
                        <BtnSearchOnTable txt='ดู' onClick={() => { GotoFilePath(item) }} /> &nbsp;&nbsp;&nbsp;
                        <Tooltip title={item.value} TransitionComponent={Zoom} placement="top-start">
                            <Typography component={"label"} style={{ wordBreak: 'break-word' }}>
                                {item.value}
                            </Typography>
                        </Tooltip>


                    </>
                );
            },
        },
    ];

    const dataColumnInform: GridColumns = [
        {
            field: "nRow",
            headerName: i18n(`${i18nField}.sNo`),
            headerAlign: "center",
            width: 40,
            editable: false,
            resizable: false,
            disableReorder: true,
            align: "center",
            sortable: false,
        },
        {
            field: "dUpdate",
            headerName: i18n(`${i18nField}.sReportDate`),
            headerAlign: "center",
            flex: 1,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 100,
            sortable: false,
            renderCell: (item) => {
                let textdate = item.value != null ?
                    (currentLanguage() == "th" ?
                        moment(item.value).add(543, 'year').format("DD/MM/YYYY HH:mm น.")
                        : moment(item.value).format("DD/MM/YYYY HH:mm"))
                    : null;

                return (
                    <Tooltip title={textdate} TransitionComponent={Zoom} placement="top-start" >
                        <Typography component={"label"} style={{ textAlign: 'center' }}>{textdate} </Typography>
                    </Tooltip>
                );
            },
        },
        {
            field: "sDetail",
            headerName: i18n(`${i18nField}.sDetail`),
            headerAlign: "center",
            flex: 5,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 100,
            sortable: false,
            renderCell: (item) => {
                return (
                    <Tooltip title={item.value} TransitionComponent={Zoom} placement="top-start" >
                        <Typography component={"label"}>{item.value} </Typography>
                    </Tooltip>
                );
            },
        },

    ];


    return (
        <>
            <div style={{ padding: !Layout1000 ? '2em 2em 0 2em' : '6em 2em 0 2em' }}>
                <Grid container spacing={2} direction="row" justifyContent="center" alignItems="start" >
                    <Grid item xs={12}>
                        <InnerHeadRoutes
                            iconMUI={<BsListUl style={{ fontSize: '1.5em' }} />}
                            labal_Head={i18n(`${i18nField}.sPetition`)}
                        />
                    </Grid>
                    <Grid item xs={12} md={nStatusID != null && Layout1000 ? 10 : 12}>
                        <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" >
                            <Grid item xs={12}>
                                <div
                                    style={{
                                        width: '100%',
                                        padding: '16px',
                                        borderRadius: '10px',
                                        border: '1px solid #d5d5d5',
                                        background: '#ffffff'
                                    }}
                                >
                                    <FormProvider {...form}>
                                        <Grid container spacing={3} direction="row" justifyContent="start" alignItems="start"  >
                                            <Grid item xs={12}>
                                                <Typography gutterBottom style={{ fontWeight: 500 }}>
                                                    {i18n(`${i18nField}.sInformationProblemReport`)}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} >
                                                <Grid container spacing={2} justifyContent="space-between" alignItems="center">
                                                    <Grid item >
                                                        <Grid container spacing={2}>
                                                            <Grid item >
                                                                <InputFormItem
                                                                    id="sVOCForm"
                                                                    name="sVOCForm"
                                                                    label={i18n(`${i18nField}.sInvoice`)}
                                                                    required={false}
                                                                    fullWidth
                                                                    disabled={true}
                                                                />
                                                            </Grid>
                                                            <Grid item style={{ display: IsReferVOC ? "" : "none" }}>
                                                                <InputFormItem
                                                                    id="sReferVOCFormCode"
                                                                    name="sReferVOCFormCode"
                                                                    label={i18n(`${i18nField}.sReference`)}
                                                                    required={false}
                                                                    fullWidth
                                                                    disabled={true}

                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item >
                                                        <InputFormItem
                                                            id="sJobCode"
                                                            name="sJobCode"
                                                            label={i18n(`${i18nField}.sSheet`)}
                                                            required={false}
                                                            fullWidth
                                                            disabled={true}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <AutoCompleteSelect
                                                    name="oVOCType"
                                                    options={OptionTypeVOC}
                                                    label={i18n(`${i18nField}.sType`)}
                                                    required={false}
                                                    disabled={true}

                                                />
                                            </Grid>
                                            <Grid item xs={12} >
                                                <InputCustomLabel
                                                    id="sDetail"
                                                    name="sDetail"
                                                    label={i18n(`${i18nField}.sDetail`)}
                                                    required={false}
                                                    disabled={true}
                                                    multiline={true}
                                                    maxLength={1000}
                                                    rows={4}
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" >
                                                    <Grid item xs={12} sm={8}>
                                                        <AutoCompleteSelect
                                                            name="oTel"
                                                            options={OptionTel}
                                                            label={i18n(`${i18nField}.sTel`)}
                                                            required={false}
                                                            disabled={true}

                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} style={{ marginTop: '-16px' }}>
                                                        <FormControlLabel
                                                            label={i18n(`${i18nField}.sApprove`)}
                                                            labelPlacement="end"
                                                            control={
                                                                <Checkbox
                                                                    checked={IsCheckTel}
                                                                    disabled={true}
                                                                />
                                                            }
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} md={6} style={{ marginTop: '-12px', display: arrAttachment.length == 0 ? "none" : "" }}>
                                                <UploadFile
                                                    id="sDocFile"
                                                    keyID={1}
                                                    sTitle={i18n(`${i18nField}.sFile`)}
                                                    IsRequired={false}
                                                    arrFile={arrAttachment || []}
                                                    setarrFile={setarrAttachment}
                                                    IsFolder={false}
                                                    IsFile={true}
                                                    IsMultiple={false}
                                                    Extension={[...Extension.PDF, ...Extension.Image, ...Extension.Word, ...Extension.Excel, ...Extension.Other]}
                                                    IsDrag={false}
                                                    nLimitFile={10}
                                                    sLimitFile={"MB"}
                                                    disabled={true}
                                                    IsHiddenUploadBox={true}

                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <AutoCompleteSelect
                                                    name="oCompany"
                                                    options={OptionCompany}
                                                    label={i18n(`${i18nField}.sCompany`)}
                                                    required={false}
                                                    disabled={true}

                                                />
                                            </Grid>
                                            <Grid item xs={12} >
                                                <AutoCompleteSelect
                                                    name="oAddress"
                                                    options={Optionlocation}
                                                    label={i18n(`${i18nField}.sAddress`)}
                                                    required={false}
                                                    disabled={true}

                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={3} md={2}>
                                                        <Typography style={{ fontWeight: 500 }}>
                                                            {i18n(`${i18nField}.sDate`)}
                                                        </Typography>
                                                        <Typography >
                                                            {sDate}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={3} md={2}>
                                                        <Typography style={{ fontWeight: 500 }}>
                                                            {i18n(`${i18nField}.sStatus`)}
                                                        </Typography>
                                                        <Typography >
                                                            {sStatus}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={3} md={2}>
                                                        <Typography style={{ fontWeight: 500 }}>
                                                            {i18n(`${i18nField}.sResponsible`)}
                                                        </Typography>
                                                        <Typography >
                                                            {sResponeName}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            {
                                                [7, 8].includes(nStatusID)
                                                    ?
                                                    <>
                                                        <Grid item xs={12}>
                                                            <InputCustomLabel
                                                                id="sResolveDetail"
                                                                name="sResolveDetail"
                                                                label={i18n(`${i18nField}.sEditDetails`)}
                                                                required={false}
                                                                multiline={true}
                                                                rows={4}
                                                                fullWidth
                                                                disabled={true}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <DataGridMuiClient
                                                                isLoading={false}
                                                                rows={DataRowResolve}
                                                                HiddenToolHead={true}
                                                                Columns={dataColumn}
                                                                backgroundHeaderCustom={"#004290"}
                                                                sxCustomHeader={{ color: '#ffffff' }}
                                                            />
                                                        </Grid>
                                                    </>
                                                    : null
                                            }
                                            {
                                                nStatusID != 8
                                                    ?
                                                    <Grid item xs={12}>
                                                        <Grid container spacing={2} direction="row" justifyContent="start" alignItems="center">
                                                            {
                                                                IsShowChatEmp == true ?
                                                                    <Grid item xs={4} sm={3}>
                                                                        <CardBox
                                                                            icon={<AiFillWechat style={{ fontSize: '2.5em', color: '#11c990' }} />}
                                                                            label={"Chat"}
                                                                            subLabel={sResponeName}
                                                                            RoleLabel={i18n(`${i18nField}.sResponsible`)}
                                                                            IsFront={true}
                                                                            onClick={() => { onGotoLiveChat() }}
                                                                            style={{
                                                                                backgroundColor: '#cdf4e8'
                                                                            }}
                                                                        />
                                                                    </Grid>
                                                                    : IsShowChatBA == true ?
                                                                        <Grid item xs={4} sm={3}>
                                                                            <CardBox
                                                                                icon={<AiFillWechat style={{ fontSize: '2.5em', color: '#11c990' }} />}
                                                                                label={"Chat"}
                                                                                subLabel={sBAserviceVOC}
                                                                                RoleLabel={"(BA Service)"}
                                                                                IsFront={true}
                                                                                onClick={() => { onGotoLiveChat() }}
                                                                                style={{
                                                                                    backgroundColor: '#cdf4e8'
                                                                                }}
                                                                            />
                                                                        </Grid>
                                                                        : null
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                    : null
                                            }
                                        </Grid>
                                    </FormProvider>
                                </div>
                            </Grid>
                            {
                                DataRowInprogress.length == 0 ?
                                    null
                                    :
                                    <Grid item xs={12}>
                                        <Accordion header={i18n(`${i18nField}.sInform`)}>
                                            <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" >
                                                <Grid item xs={12}>
                                                    <DataGridMuiClient
                                                        isLoading={false}
                                                        rows={DataRowInprogress}
                                                        HiddenToolHead={true}
                                                        Columns={dataColumnInform}
                                                        backgroundHeaderCustom={"#004290"}
                                                        sxCustomHeader={{ color: '#ffffff' }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Accordion>
                                    </Grid>
                            }
                            {
                                objScore.isShow == true ?
                                    <Grid item xs={12}>
                                        <Accordion header={i18n(`${i18nField}.sScoreRating`)}>
                                            <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" >
                                                {
                                                    objScore.lstQ != null && objScore.lstQ.length > 0 ?
                                                        <>
                                                            {
                                                                (objScore.lstQ).map((element, idx) => {
                                                                    return (
                                                                        <Grid item xs={12}>
                                                                            <Typography>
                                                                                {idx + 1}.&nbsp;{element.sQuestion}&nbsp;&nbsp; {i18n(`${i18nField}.sScore`)}&nbsp;&nbsp;
                                                                                {element.sScore == "0" ? "0" : element.sScore == "N/A" ? "N/A" : <Rating value={element.nScore} max={element.nScore} readOnly />}

                                                                            </Typography>
                                                                        </Grid>
                                                                    )
                                                                })
                                                            }
                                                        </>
                                                        :
                                                        null
                                                }
                                                <Grid item xs={12}>
                                                    <Typography style={{ fontWeight: 500 }}>
                                                        {i18n(`${i18nField}.sFeedback`)}
                                                    </Typography>
                                                    <Typography >
                                                        {objScore.sSuggestion}
                                                    </Typography>
                                                </Grid>

                                            </Grid>
                                        </Accordion>
                                    </Grid>
                                    :
                                    null
                            }
                            <Grid item xs={12} style={{ display: nStatusID != null && !Layout1000 ? '' : 'none' }}>
                                <VerticalStepper sVOCFormID={sVOCFormID} />
                            </Grid>
                            {
                                sMode === "view"
                                    ?
                                    <Grid item >
                                        <BtnBack onClick={() => { onGotoBack() }} />
                                    </Grid>
                                    :
                                    [7].includes(nStatusID)
                                        ?
                                        <>
                                            {
                                                nJobTypeID === 1
                                                    ?
                                                    <>
                                                        <Grid item >
                                                            <BtnSave txt={i18n(`common.sAccept`)} onClick={() => { setIsOpenRating(true); }} />
                                                        </Grid>
                                                        <Grid item >
                                                            <BtnReject txt={i18n(`common.sReject`)} onClick={() => { setIsOpenReject(true); }} />
                                                        </Grid>
                                                        <Grid item >
                                                            <BtnRecycle txt={i18n(`common.newRequest`)} onClick={() => { GotoReferVOC() }} />
                                                        </Grid>
                                                    </>
                                                    : null
                                            }
                                            {
                                                nJobTypeID === 2
                                                    ?
                                                    <>
                                                        <Grid item >
                                                            <BtnRecomment txt={i18n(`common.sRate`)} onClick={() => { setIsOpenRating(true); }} />
                                                        </Grid>
                                                        <Grid item >
                                                            <BtnRecycle txt={i18n(`common.newRequest`)} onClick={() => { GotoReferVOC() }} />
                                                        </Grid>
                                                    </>
                                                    : null
                                            }
                                            <Grid item >
                                                <BtnBack txt={i18n(`common.back`)} onClick={() => { onGotoBack() }} />
                                            </Grid>
                                        </>
                                        :
                                        <>
                                            <Grid item >
                                                <BtnBack txt={i18n(`common.back`)} onClick={() => { onGotoBack() }} />
                                            </Grid>
                                        </>
                            }
                        </Grid>

                    </Grid>
                    <Grid item xs={12} md={2} style={{ display: sVOCFormID != null && Layout1000 ? '' : 'none' }}>
                        <VerticalStepper sVOCFormID={sVOCFormID} />
                    </Grid>
                </Grid>
            </div>
            <SnackbarCustom
                IsOpen={IsOpenSnackbar}
                Severity={sSeveritySnackbar}
                OnClose={() => { setIsOpenSnackbar(false) }}
                Message={sMessageSnackbar}
            />
            <ModalReject
                IsOpen={IsOpenReject}
                setIsOpen={setIsOpenReject}
                sVOCFormID={sVOCFormID}
                setIsOpenSnackbar={setIsOpenSnackbar}
                setsSeveritySnackbar={setsSeveritySnackbar}
                setsMessageSnackbar={setsMessageSnackbar}
            />
            <ModalRating
                IsOpen={IsOpenRating}
                setIsOpen={setIsOpenRating}
                sResponeName={sResponeName}
                sVOCFormID={sVOCFormID}
                setIsOpenSnackbar={setIsOpenSnackbar}
                setsSeveritySnackbar={setsSeveritySnackbar}
                setsMessageSnackbar={setsMessageSnackbar}
                setIsAlertInfo={setIsAlertInfo}
                IsAlertInfo={IsAlertInfo}
            />
             <PopUpCustom
                setIsOpen={setIsAlertInfo}
                IsOpen={IsAlertInfo}
                sMaxWidth={'sm'}
                JsxDialogHeader={
                    <>
                        <Typography>{i18n(`${i18nField}.sReportResults`)}</Typography>
                    </>
                }
                JsxDialogContent={
                    currentLanguage() == "th" ?
                        <>
                            <Typography>ขอบคุณสำหรับคำแนะนำและติชม ที่เป็นประโยชน์และเป็นกำลังใจให้ทีมงานได้พัฒนาผลิตภัณฑ์และบริการให้ดียิ่งขึ้นต่อไป</Typography>
                        </>
                        :
                        <>
                            <Typography>Thank you for your advice and comments. That is useful and encourages the team to continue to develop products and services better.</Typography>
                        </>
                }
                JsxDialogAction={
                    <>
                        <Grid container spacing={1} direction="row" justifyContent="end" alignItems="center">
                            <Grid item >
                                <BtnCancelInModal
                                    txt={currentLanguage() == "th" ? "ปิด" : "close"}
                                    onClick={() => { setIsAlertInfo(false);navigate("/Front/MyVOC"); }} />
                            </Grid>
                        </Grid>
                    </>
                }
            />
        </>
    )
}

export default HomeVOCForm